import { ProductPriceData } from "@domain/product/product-price-data";
import { Expose, Type } from "class-transformer";

export class ProductCountryData {
  @Expose()
  countryCode!: string;

  @Expose()
  @Type(() => ProductPriceData)
  prices: ProductPriceData[] = [];
}
